export const disassociatedStyles = {
  actionButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
  },
  actionNote: {
    color: '#979598',
    fontFamily: 'Red Hat Display Regular',
    fontSize: '13px',
    maxWidth: '520px',
  },
  actionRow: {
    alignItems: 'center',
    borderTop: '1px solid #E0E0E0',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    justifyContent: 'space-between',
    marginTop: '16px',
    paddingTop: '16px',
  },
  alert: {
    fontFamily: 'Red Hat Display Regular',
    fontSize: '13px',
    marginBottom: '16px',
  },
  alertHead: {
    color: '#292929',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: 13,
  },
  alertLine: {
    color: '#292929',
    fontFamily: 'Red Hat Display Regular',
    fontSize: 13,
    paddingTop: '4px',
  },
  centered: {
    display: 'flex',
    justifyContent: 'center',
    padding: '48px 0',
  },
  chip: {
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: '11px',
  },
  consultantName: {
    color: '#292929',
    fontFamily: 'Red Hat Display Bold',
    fontSize: 15,
  },
  counts: {
    color: '#979598',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: 13,
  },
  detailField: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  detailGrid: {
    display: 'grid',
    gap: '16px',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    marginBottom: '18px',
  },
  detailLabel: {
    color: '#979598',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: 11,
    letterSpacing: '0.4px',
    textTransform: 'uppercase',
  },
  detailValue: {
    color: '#292929',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: 14,
  },
  emptyBox: {
    border: '1.5px solid #E0E0E0',
    borderRadius: '8px',
    padding: '40px 20px',
    textAlign: 'center',
  },
  emptyText: {
    color: '#979598',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: 14,
  },
  headerRow: {
    marginBottom: '18px',
  },
  metaLine: {
    color: '#979598',
    fontFamily: 'Red Hat Display Regular',
    fontSize: 12,
    paddingTop: '4px',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    overflowY: 'auto',
    padding: '32px 16px',
  },
  modalBox: {
    background: '#FFFFFF',
    borderRadius: '10px',
    height: 'fit-content',
    maxWidth: '900px',
    outline: 'none',
    padding: '24px',
    width: '100%',
  },
  modalClose: {
    color: '#292929',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: '14px',
    textDecoration: 'underline',
    textTransform: 'capitalize',
  },
  modalHead: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '18px',
  },
  modalSummary: {
    background: '#F6F6F6',
    borderRadius: '6px',
    color: '#292929',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: 13,
    marginBottom: '16px',
    padding: '10px 12px',
  },
  modalTitle: {
    color: '#292929',
    fontFamily: 'Red Hat Display Bold',
    fontSize: 18,
  },
  noDestination: {
    color: '#979598',
    fontFamily: 'Red Hat Display Regular',
    fontSize: 12,
  },
  page: {
    padding: '24px',
  },
  projectName: {
    color: '#241a2e',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: 13,
  },
  reasonBlock: {
    borderTop: '1px solid #E0E0E0',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginBottom: '16px',
    paddingTop: '16px',
  },
  reasonLabel: {
    color: '#292929',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: 12,
  },
  reasonLine: {
    color: '#292929',
    fontFamily: 'Red Hat Display Regular',
    fontSize: 12,
    paddingTop: '2px',
  },
  reasonText: {
    color: '#292929',
    fontFamily: 'Red Hat Display Regular',
    fontSize: 14,
  },
  resolveButton: {
    '&:hover': { background: '#A00000' },
    background: '#BF0000',
    borderRadius: '8px',
    fontFamily: 'Red Hat Display Bold',
    fontSize: '14px',
    textTransform: 'capitalize',
  },
  reviewButton: {
    borderColor: '#E0E0E0',
    borderRadius: '8px',
    color: '#292929',
    fontFamily: 'Red Hat Display Bold',
    fontSize: '14px',
    textTransform: 'capitalize',
  },
  subTitle: {
    color: '#979598',
    fontFamily: 'Red Hat Display Regular',
    fontSize: 13,
    marginTop: '4px',
    maxWidth: '760px',
  },
  switchLabel: {
    color: '#292929',
    fontFamily: 'Red Hat Display SemiBold',
    fontSize: 13,
  },
  // .tableview supplies the head padding and body cell treatment; these only pin the type
  // to the same scale the rest of the admin tables use.
  tableCell: {
    color: '#292929',
    fontFamily: 'Red Hat Display Medium',
    fontSize: 13,
  },
  title: {
    color: '#292929',
    fontFamily: 'Red Hat Display Bold',
    fontSize: 20,
  },
  toolbar: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    justifyContent: 'space-between',
    marginBottom: '16px',
  },
};
